import { render, staticRenderFns } from "./DocumentWorkspaceDialog.vue?vue&type=template&id=95259af6&scoped=true"
import script from "./DocumentWorkspaceDialog.vue?vue&type=script&lang=js"
export * from "./DocumentWorkspaceDialog.vue?vue&type=script&lang=js"
import style0 from "./DocumentWorkspaceDialog.vue?vue&type=style&index=0&id=95259af6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95259af6",
  null
  
)

export default component.exports